import get from 'lodash.get';

function getSupportedCategoriesForRegeneration(rootState) {
  return get(rootState, 'ws.template.meta.supportedBlockCategoriesForRegeneration', []);
}

export default getSupportedCategoriesForRegeneration;
